<template>
  <el-container style="width: 100%;height: 100%;display: flex;flex-direction: column;">
    <el-row style="width: 100%; height: 48px;margin-bottom: 1px;background-color: #ffffff;">
      <el-menu default-active="1" class="horizontal-menu" @select="menuSelect"
               mode="horizontal" unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(0, 0, 0, 1)">
        <template v-for="sub in energyItem">
          <el-menu-item class="horizontal-menu-item" :key="sub.id" :index="sub.id">
            <span style="font-size: 14px;">{{sub.name}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-row>
    <el-row style="width: 100%;height: calc(100% - 49px);display: flex;flex-direction: row;">
      <el-aside style="height: 100%;width: 250px;margin-right: 1px;background-color: #ffffff;">
        <el-row class="doc-tree-top">
          <el-input style='width: 100%; border: none; outline: none' class="filter-search" placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
        </el-row>
        <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick" node-key='id' :filter-node-method="filterNode"
                 :default-expanded-keys="expandKeys" highlight-current ref="tree" class="aside-tree">
        <span slot-scope="{ node, data }">
          <i v-if="node.data.type === '1'" class="zy-icon-building"></i>
          <i v-if="node.data.type === '2'" class="zy-icon-commit"></i>
          <i v-if="node.data.type === '3'" class="zy-icon-sensor"></i>
          <span>{{ node.label }}</span>
        </span>
        </el-tree>
      </el-aside>
      <el-main style="overflow-y: hidden;font-size: 14px;width: calc(100% - 251px);height: 100%;background-color: #ffffff;">
        <el-row class="tt-input" style="width: 100%;height: 48px;line-height: 48px;color: rgb(127, 127, 127);text-align: left;">
          <span style="margin-left: 24px;">时间：</span>
          <el-radio-group v-model="radio" @change="selBack" style="margin-left: 8px;" size="small">
            <el-radio-button label="年"></el-radio-button>
            <el-radio-button label="月"></el-radio-button>
          </el-radio-group>
          <el-date-picker v-model="startDate" style="width: 140px;margin-left: 16px" :type="type"
                          placeholder="选择日期" :value-format="format" :clearable="false"/>
          <el-button class="search-btn-blue" style="margin-left: 16px;" @click="getChartData" type="primary" size="mini">查询</el-button>
          <el-button class="search-btn-blue" style="margin-left: 20px;" @click="toExcel" type="primary" size="mini">导出</el-button>
        </el-row>
        <el-row style="background-color: #fff;width: 100%; height: 1px;"></el-row>
        <el-row style="overflow: hidden;height: calc(100% - 49px);width: 100%;" class="table">
          <el-table border fit height="100%" width='100%' :data="tableData" ref="tableData">
            <el-table-column v-for="(item,i) in tableProps" :key="i"
                             :prop="item.prop" :label="item.label" :width="(i===0)?'166px':'110px'">
            </el-table-column>
          </el-table>
        </el-row>
      </el-main>
    </el-row>
  </el-container>
</template>

<script>
import {Message} from "element-ui";
import DateUtils from "../../../utils/DateUtils";
import * as axios from "axios";
export default {
  name: "DemandReport",
  data() {
    return {
      timestamp: 0,
      radio: '月',
      selNode: '',
      treeData: [],
      expandKeys: [],
      defaultProps: {
        children: 'childNode',
        label: 'name'
      },
      type: 'month',
      dateType: 2,
      startDate: new Date().Format('yyyy-MM'),
      tableProps: [
      ],
      tableData: [],
      format: 'yyyy-MM',
      nodeType: '',
      energyItem: [{'id': '1', 'name': '电'}],
      unit: 'kWh',
      media: '1'
    }
  },
  created() {
    this.getTree('1')
  },
  methods: {
    menuSelect(val) {
      this.tableData = []
      this.chartData = []
      this.media = val
      this.getTree(val)
      if (val === '1') {
        this.unit = 'kWh'
      } else {
        this.unit = 'm³'
      }
    },
    getTree(val) {
      this.$api.systemManage.getSensorTree(val).then(res => {
        this.treeData = res.data
        if (this.treeData && this.treeData.length > 0) {
          this.selNode = this.getLeafNode(this.treeData[0]);
          let nodeIdName = 'id';
          this.$nextTick(function () {
            this.setTreeCurrent(this.selNode[nodeIdName], 1);
          })
        }
      })
    },
    handleNodeClick(cNode, node) {
      this.selNode = cNode
      if(node.data.type === '3') {
        this.getChartData()
      }
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0]);
      }
      return leafNode;
    },
    handlePageChange(pageNo) {
      this.currPageNo = pageNo;
      this.getChartData();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.getChartData();
    },
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件');
      let tree = this.$refs.tree;
      if (tree) {
        tree.setCurrentKey(key);
        this.expandKeys.push(key);
        let node = tree.getNode(key);
        if (key !== -1) tree.$emit("node-click", node.data, node, tree);
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    selBack(val) {
      if(val === '年') {
        this.dateType = 3
        this.type = 'year'
        this.startDate = new Date().Format('yyyy')
        this.format = 'yyyy'
      }
      if(val === '月') {
        this.dateType = 2
        this.type = 'month'
        this.startDate = new Date().Format('yyyy-MM')
        this.format = 'yyyy-MM'
      }
      this.getChartData()
    },
    getChartData() {
      if (this.selNode.type !== '3') {
        return
      }
      let params = {'id': this.selNode.id, 'dataDate': this.startDate, 'dateType': this.dateType}
      this.$api.energyReport.getDemandForm(params).then(res => {
        this.tableProps = res.data.itemList
        this.$nextTick(() => {
          this.$refs.tableData.doLayout()
          this.tableData = res.data.tableList
        })
      })
    },
    toExcel() {
      let param = []
      param.push(this.dateType)
      param.push(this.startDate)
      param.push(this.selNode.id);
      let paramStr;
      paramStr = '/energyReport/demandForm' + '/exportExcel?searchData=' + param.join('_');
      paramStr += '_' + sessionStorage.getItem('token');
      window.open(axios.defaults.baseURL + paramStr);
    }
  }
}
</script>

<style scoped>
  .doc-tree-top{
    display: inline-flex;
    align-items: center;
    height: 49px;
    width: 250px;
    border-bottom: 1px solid #fff;
  }
  /*.table /deep/ .el-table tr {*/
  /*  background-color: transparent!important;*/
  /*}*/
  .table /deep/ .el-table th {
    background-color: rgba(2, 124, 247, 0.2);
    border-top: 0;
  }
  /*.table /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{*/
  /*  background-color: transparent;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/FormManage/DemandReport.vue